import { render } from "./Usaha.vue?vue&type=template&id=264c188e"
import script from "./Usaha.vue?vue&type=script&lang=js"
export * from "./Usaha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__